module.exports = __webpack_public_path__ + "img/SUPA_Organism.f5c6be8d.png";